import React from "react";
import Style from "../Style/Navigation.module.scss";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import morn from "../Img/mordernit.png";
import born from "../Img/9.png";

const Navigationbar = () => {
  return (
    <div className={Style.Navigation}>
      <Swiper
        modules={[Navigation, Autoplay, EffectFade]}
        loop={true}
        navigation={true}
        effect="fade"
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        speed={1200}
        className={Style.NavigationFlex}
      >
        <SwiperSlide>
          <div className={Style.NavigationFirst}>
            <img
              src={morn}
              alt="banner"
              className={Style.BannerImage}
              loading="eager"
            />
            <div className={Style.NavigationText}>
              <h1>Reclaim Your Confidence. Redefine Your Image.</h1>
              <p>
                Rise as a Global Citizen. Empowering individuals through image,
                skills, and mindset transformation.
              </p>
              <Link to="/about-us" className={Style.ExploreBtn}>
                Explore More
              </Link>
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className={Style.NavigationFirst}>
            <img
              src={born}
              alt="banner"
              className={Style.BannerImage}
              loading="lazy"
            />
            <div className={Style.NavigationText}>
              <h1>Let’s Optimyz Your Life</h1>
              <p>
                Book a free clarity call or explore your personalized training
                journey. One skill at a time.
              </p>
              <Link to="/about-us" className={Style.ExploreBtn}>
                Explore More
              </Link>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Navigationbar;
